/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';

import type { LinkedImageList, Reference, SiteFooter } from '@swf/cms';
import { CMSFooter } from '@swf/cms';
import type { Menu, SocialIcons } from '@swf/core/types/CMS';
import type { WidgetFC, WidgetInstanceProps } from '@swf/core/types/Widget';
import type { FooterWidgetServices } from '@swf/generated/types/widgets/FooterWidget';

export interface CMSData {
  footnote: string;
  logos: Menu;
  socialIcons: SocialIcons;
  socialMedia?: LinkedImageList[];
  menu: { label: string; items: Menu }[];
}

export type Props = WidgetInstanceProps<unknown, FooterWidgetServices, { cms: CMSData }>;

const FooterWidget: WidgetFC<Props> = ({ data }) => {
  if (!data?.cms) return null;

  const { menu, logos, footnote, socialMedia } = data.cms;
  const footer = {
    copyright: footnote,
    logos: logos.map(({ className, image, href: url }) => ({ class: className, image, url })),
    menu: menu.map(({ label: title, items }) => ({
      title,
      links: items.map(({ children: title, href: url }) => ({ title, url }))
    })),
    social_media: socialMedia as Reference[]
  } as SiteFooter;

  return <CMSFooter {...footer} />;
};

export default FooterWidget;
